import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
    selector: 'currency-formly-field-input',
    template: `
    <mat-form-field class="w-full float-left">
        <mat-label>{{props.label}}</mat-label>
        <input matInput 
            [formControl]="formControl" 
            [formlyAttributes]="field" 
            [required]="props.required"
            [allowNegativeNumbers]="props.allowNegativeNumbers || false" 
            thousandSeparator="," 
            mask="separator.2" 
            prefix="$">
    </mat-form-field>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, NgxMaskDirective, FormsModule, ReactiveFormsModule, FormlyModule]
})
export class CurrencyInputFieldTypeComponent extends FieldType<FieldTypeConfig> { }
